export { default as Intro } from "./intro/intro";
export { default as PartnershipsImageCarousel } from "./image-carousel/image-carousel";
export { default as Overview } from "./partners-overview/partners-overview";
